import { render } from "./Footers.vue?vue&type=template&id=56b8ebc8&scoped=true"
import script from "./Footers.vue?vue&type=script&lang=js"
export * from "./Footers.vue?vue&type=script&lang=js"

import "./Footers.vue?vue&type=style&index=0&id=56b8ebc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b8ebc8"],['__file',"src/js/components/Footers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56b8ebc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56b8ebc8', __exports__)) {
    api.reload('56b8ebc8', __exports__)
  }
  
  module.hot.accept("./Footers.vue?vue&type=template&id=56b8ebc8&scoped=true", () => {
    api.rerender('56b8ebc8', render)
  })

}


export default __exports__